/* eslint-disable @typescript-eslint/member-ordering */
import { Component, inject } from '@angular/core'
import { MatSnackBarRef } from '@angular/material/snack-bar'
import { Subject } from 'rxjs'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
@Component({
  selector: 'customer-portal-matomo-consent-snackbar',
  standalone: true,
  templateUrl: './consent-snackbar.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class ConsentSnackbarComponent {
  private readonly snackBarRef = inject(MatSnackBarRef<any>)

  private readonly _actionClicked = new Subject<'accept' | 'decline'>()
  onActionClicked = this._actionClicked.asObservable()

  protected accept (): void {
    this._actionClicked.next('accept')
    this.snackBarRef.dismiss()
  }

  protected decline (): void {
    this._actionClicked.next('decline')
    this.snackBarRef.dismiss()
  }
}
